<template>
<v-menu
  open-on-hover
  :close-on-content-click="false"
  v-model="menuOpened"
  :nudge-width="450"
  max-width="600"
  transition="scale-transition"
  >
  <template v-slot:activator="{ on }">
    <v-chip class="mr-2 mt-2 pb-6 pt-6" v-on="on">
      <div>
        + {{ quantidadeFornecedoresRestantes }}
        <div></div>
      </div>
    </v-chip>
  </template>
  <v-card>
    <v-card-text class="text--primary mt-0 pt-2">
      <px-selecao-fornecedor-chip v-for="fornecedor in fornecedoresVisiveis"
                                  :key="fornecedor.id"
                                  :fornecedor="fornecedor"
                                  @remove="onRemoveItem"/>
    </v-card-text>
  </v-card>
  </v-menu>
</template>

<script>
import PxSelecaoFornecedorChip
  from '@/components/lista-selecao-fornecedor/PxSelecaoFornecedorChip.vue';

const FORNECEDORES_VISIVEIS = 5;

export default {
  props: {
    fornecedores: {
      type: Array,
    },
  },
  data() {
    return {
      menuOpened: false,
    };
  },
  computed: {
    fornecedoresVisiveis() {
      if (!this.fornecedores || !this.fornecedores.length) {
        return [];
      }
      return this.fornecedores.slice(FORNECEDORES_VISIVEIS);
    },
    quantidadeFornecedoresRestantes() {
      if (!this.fornecedores || !this.fornecedores.length) {
        return 0;
      }
      return this.fornecedores.length - FORNECEDORES_VISIVEIS;
    },
  },
  methods: {
    onRemoveItem(requisicaoProduto) {
      this.$emit('remove', requisicaoProduto);
    },
  },
  components: {
    PxSelecaoFornecedorChip,
  },
};
</script>
